import Ezequiel from 'src/assets/MeetOurTeam/new/eze_3_11zon.a72b8e82_14_11zon_11zon.avif'
import Victor from 'src/assets/MeetOurTeam/new/vic_9_11zon.3a6fb8c5_20_11zon_11zon.avif'
import Sebastian from 'src/assets/MeetOurTeam/new/sebas_7_11zon.2fdb713d_18_11zon_11zon.avif'
import Santiago from 'src/assets/MeetOurTeam/new/santiago_6_11zon.bc2a2110_17_11zon_11zon.avif'
import Jonathan from 'src/assets/MeetOurTeam/new/jonathan_4_11zon.c62d30ec_15_11zon_11zon.avif'
import Karla from 'src/assets/MeetOurTeam/new/karla_5_11zon.9138f0fd_16_11zon.avif'
import Sibrim from 'src/assets/MeetOurTeam/new/sibrim_8_11zon.97a6f711_19_11zon_11zon.avif'
import Git_Ezequiel from 'src/assets/gitTeam/Eze.webm'
import Git_Victor from 'src/assets/gitTeam/victor.webm'
import Git_Sebastian from 'src/assets/gitTeam/Sebas.webm'
import Git_Santiago from 'src/assets/gitTeam/santi.webm'
import Git_Jonathan from 'src/assets/gitTeam/Jhonatan.webm'
import Git_Karla from 'src/assets/gitTeam/Karla.webm'
import {
    animationVariantsRightSuccess,
    scaleVariantSuccess,
} from 'src/theme/animations/swipeIn'
import { MeetLabels } from 'src/types'
import { useTranslations } from 'src/provider/LocaleProvider'

export function MeetOurTeamLabels() {
    const t = useTranslations()
    const MeetOurTeamInformation: MeetLabels[] = [
        {
            id: 1,
            image: Sebastian,
            name: 'Sebastian Bárcenas',
            WorkField: t('meetOurTeam.team.sebastian.workField'),
            textCity: t('meetOurTeam.team.sebastian.information'),
            animation: scaleVariantSuccess,
            video: Git_Sebastian,
        },
        {
            id: 2,
            image: Santiago,
            name: 'Santiago Bárcenas',
            WorkField: `${t('meetOurTeam.team.santiago.workField')}`,
            textCity: `${t('meetOurTeam.team.santiago.information')}`,
            animation: animationVariantsRightSuccess,
            video: Git_Santiago,
        },
        // {
        //     id: 3,
        //     image: Girl,
        //     name: 'Jéssica Monsalve',
        //     animation: scaleVariantSuccess,
        //     WorkField: 'Human Talent Manager ',
        //     WorkFieldSpanish: ' Directora de Talento Humano ',
        //
        //     textCity:
        //         ' She designs and implements strategies for the acquisition of human talent, she is a fundamental pillar in the team. She enjoys reading and watching the sunset.',
        //     textCityEs:
        //         'Diseña e implementa estrategias para la adquisición de talento humano, es un pilar fundamental en el equipo. Le gusta leer y ver el atardecer.',
        //     video: 'https://blur-effect.s3.amazonaws.com/public/Karla.mp4',
        // },
        {
            id: 3,
            image: Ezequiel,
            name: 'Ezequiel Bahoque',
            WorkField: `${t('meetOurTeam.team.ezequiel.workField')}`,
            textCity: `${t('meetOurTeam.team.ezequiel.information')}`,
            animation: scaleVariantSuccess,
            video: Git_Ezequiel,
        },
        {
            id: 4,
            image: Jonathan,
            name: 'Jonathan Monsalve',
            WorkField: `${t('meetOurTeam.team.jonathan.workField')}`,
            textCity: `${t('meetOurTeam.team.jonathan.information')}`,
            animation: animationVariantsRightSuccess,
            video: Git_Jonathan,
        },
        {
            id: 5,
            image: Karla,
            name: 'Karla Castilla',
            WorkField: `${t('meetOurTeam.team.karla.workField')}`,
            textCity: `${t('meetOurTeam.team.karla.information')}`,
            video: Git_Karla,
        },
        {
            id: 6,
            image: Victor,
            name: 'Víctor De la Hoz',
            WorkField: t('meetOurTeam.team.víctor.workField'),
            textCity: t('meetOurTeam.team.víctor.information'),
            video: Git_Victor,
        },
        {
            id: 7,
            image: Sibrim,
            name: 'Sibrin Barcenas',
            WorkField: `${t('meetOurTeam.team.sibrin.workField')}`,
            textCity: `${t('meetOurTeam.team.sibrin.information')}`,
            video: '',
        },
    ]

    return { MeetOurTeamInformation }
}
